<template>
  <div>
    <h1 class="error-number mb-2">404</h1>
    <h2　class="mb-2">Sorry but we couldn't find this page</h2>
    <p>The page you are looking for does not exist</p>
    <div>
     <small>Copyright © 2018 Aplix and/or its affiliates. All rights reserved.</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Page404.vue